// src/i18n/cards.ts —— C-05 用户卡片 / C-06 消费明细 / C-28 暂扣释放 / C-29 卡操作单文案包（经 PageDef.i18n 挂入 table 域字典，TD-849）。
// 06 给出文案的键逐字取 06；06 只给 zh 或未给文案的键由本计划定稿（W-7 回写）。base 包（i18n/table.ts）与外壳包的键只引用不定义
import type { I18nPack } from '../../../shared/src/dc';

export const I18N_CARDS: I18nPack = {
  zh: {
    // 06 [改写 key]（原型字典键，列入 REWRITES_CARDS）
    tabCards: ['全部', '正常', '冻结', '审核中', '充值中', '销卡审核', '已注销', '失败'], // C-05 追加 FAILED（B-8）
    closeCardText: '将先冻结该卡并记录已消费快照，再向上游删卡；完成后按 可退额度 = max(0, 上游限额 − 最终已消费) 扣除销卡费 min(销卡费, 可退额度) 后退回用户钱包；暂扣额不退、留存待人工处理。不可撤销。',
    toastRecharge: '已提交增加额度',
    toastWithdraw: '已提交卡转出',
    toastCloseCard: '销卡已提交，完成后退回用户钱包',
    toastMock: 'Mock 交易已下发，已生成 card.transaction.update 回调', // 附录 A-13 取长文案
    cardMockTitle: 'Mock 交易 · {card}', cardMockTip: '仅测试环境：向上游沙箱发起一笔模拟交易并触发回调。默认「授权 → 结算」，会按卡产品费率计收交易手续费并推送扣费通知。', cardMockMerchant: '商户名（可选）', cardMockTransition: '授权后状态', cardMockTr_Settle: '结算（推荐，触发计费）', cardMockTr_none: '仅授权', cardMockTr_Auth_Delete: '撤销授权', cardMockTr_Refund: '退款', cardMockTr_Dispute: '争议', cardMockMerchantTooLong: '商户名最多 255 个字符',
    // 对已有交易的 Mock 状态流转（仅 dev / sandbox；POST /api/admin/card-transactions/{id}/mock-transition）
    aMockTransition: 'Mock 流转', mockTrTitle: 'Mock 流转 · {tx}', mockTrTip: '仅测试环境：对上游已有交易做状态流转并触发回调；本地交易状态以回调入库为准，稍后刷新查看。金额留空则按原交易金额。', mockTrStatus: '目标状态', mockTrAmount: '金额（可选，USD）', mockTrTo_Auth_Delete: '撤销授权', mockTrTo_Settle: '结算', mockTrTo_Refund: '退款', mockTrTo_Dispute: '争议', toastMockTr: '已提交 Mock 流转，等待上游回调入库',
    upLoading: '正在获取上游数据…', upNoResponse: '上游暂时无响应', aUpRetry: '重试',
    aRecharge: '代增加额度', // C-05「代充值 / 代提现」改为「代增加额度 / 代卡转出」（D30）
    aWithdraw: '代卡转出',
    // C-05 [新增 key]
    cardTopupTitle: '代增加额度 · {card}',
    cardWithdrawTitle: '代卡转出 · {card}',
    cardOpTip: '与用户自助走同一链路（operator=admin）；提交后由后台任务执行，结果见卡操作单与时间线',
    stInflight: '处理中',
    stillRunning: '仍在处理，请稍后刷新',
    upReadErr: '上游暂不可读',
    spentDirty: '交易已入库，已消费待同步',
    spentUnverified: '上游消费快照待核对；≥ 为已知消费下界，≤ 为可用额上界',
    aReconcile: '手动对账',
    toastReconcile: '已触发对账，结果以对账任务为准',
    crossBorder: '跨境',
    stTxUnknown: '未知', // C-06 [新增 key]
    actOpen: '开卡',
    actRecharge: '增加额度',
    actWithdraw: '卡转出',
    actClose: '销卡',
    actFreeze: '冻结',
    actUnfreeze: '解冻',
    actHold: '暂扣',
    actRelease: '释放',
    actReclaim: '迟到认领回收',
    caSubmitted: '已提交',
    caAccepted: '上游处理中',
    caSuccess: '成功',
    caFailed: '失败',
    // C-28 [新增 key]
    cardHoldTitle: '暂扣额度 · {card}',
    cardReleaseTitle: '释放暂扣 · {card}',
    holdReviewTip: '金额超过 {threshold}，提交后需另一名管理员复核',
    toastHold: '已提交暂扣',
    toastRelease: '已提交释放',
    crdPendingReview: '待复核', // C-28「需复核时 toast 追加「· 待复核」」（原型 pendingReview 为「待审核」，不改写）
    // C-29 [新增 key]
    tabCardActions: ['全部', '待复核', '待对账', '失败'],
    toastApprove: '已复核通过',
    toastReject: '已驳回',
    stepAwaitReview: '待复核',
    stepBudgetTopup: '预算充值',
    stepCreateCard: '建卡',
    stepFetchDetail: '取卡面',
    stepLimitSync: '已消费复核',
    stepLimitUpdate: '改限额',
    stepStatusUpdate: '改状态',
    stepSnapshot: '已消费快照',
    stepDeleteCard: '删卡',
    stepFinalize: '收尾',
    stepBudgetWithdraw: '预算转出',
    stepDone: '完成',
    reconOutcomeClaimed: '已认领',
    reconOutcomeRequeued: '确认未生效，已退回重发',
    reconOutcomeRoundCounted: '本轮未命中',
    reconOutcomeAmbiguous: '多个候选，需人工绑定',
    reconOutcomeFailed: '判失败（开卡 / 增加额度）',
    reconOutcomeAwaitManual: '转人工结案',
    reconOutcomeQueryFailed: '上游查询失败（不计轮）',
    reconOutcomeNotUnknown: '单据已离开待对账',
    reconOutcomeResumeRejected: '未能推进（保持待对账）',
    reconOutcomeBudgetClaimed: '等待的预算充值单已认领',
    reconOutcomeBudgetPending: '等待的预算充值单未认领',
    crdOutcomeSuccess: '上游已生效',
    crdOutcomeFailed: '上游未生效',
    crdSsPending: '待执行',
    crdSsSent: '已发出',
    crdSsAccepted: '上游已受理',
    crdSsUnknown: '待确认',
    crdSsWaiting: '等待',
    // 06 列名 / 字段名原文
    cTotalLimit: '总额度',
    cAvailable: '已消费 / 可用',
    cHeld: '暂扣',
    cExpiry: '有效期',
    cBillingAddr: '账单地址',
    crdBizNo: '单号',
    crdAction: '动作',
    crdCard: '卡',
    crdStep: '步骤',
    crdOperator: '发起',
    crdReasonErr: '原因 / 错误',
    crdError: '错误',
    crdNote: '备注',
    crdCaps: '能力位',
    crdFees: '费率',
    crdFinal: '已销卡定稿',
    crdReviewer: '复核人',
    crdResolver: '结案人',
    crdCreatedAt: '创建时间',
    crdFinalizedAt: '终结时间',
    crdTotal: '合计',
    crdFee: '手续费',
    limitLocal: '对客额度',
    limitUpstream: '上游限额',
    // 以下本计划定稿（W-7 回写）
    crdErrAmount: '请输入大于 0 的金额（最多 2 位小数）',
    errReleaseOverHeld: '释放金额不能超过当前暂扣',
    errUpstreamCardId: '开卡判成功须填写上游卡号',
    errResolveNotApplied: '单据状态已变化，结案未生效，请刷新后重试',
    pendingUnknownTip: '该卡有待对账的卡操作',
    aOpenCard: '打开卡片',
    aHold: '暂扣',
    aRelease: '释放',
    holdTip: '当前 总额度 {total} / 暂扣 {held} / 上游限额 {upstream} / 已消费 {spent}。',
    caApproveTitle: '确认复核通过',
    caApproveText: '通过后单据继续执行，不可撤销。',
    limitTotal: '总额度',
    limitSpent: '已消费',
    limitAvailable: '可用',
    cSpent: '已消费',
    upLimit: '上游限额',
    crdUpRejected: '上游拒绝',
    crdUpUnavailable: '不可用',
    crdFeeOpen: '开卡费',
    crdFeeClose: '销卡费',
    crdFeeTx: '交易手续费',
    crdFeeCross: '跨境费',
    crdFeeDeclined: '拒付费',
    crdFeeDispute: '争议费',
    crdBudgetSub: '预算 #{id}',
    crdFeeLedger: '流水 {biz_no} · 实扣 {charged}',
    crdOpUser: '用户',
    crdOpAdmin: '管理员',
    crdOpSystem: '系统',
    crdYes: '是',
    crdNo: '否',
    // 2026-10-17 后台卡面明文查看（POST /api/admin/cards/{id}/secret，cardSecret.view；06 C-05 抽屉「显示卡号」）
    aRevealCard: '显示卡号', aRevealHide: '隐藏卡号', aRevealCopyPan: '复制卡号', aRevealCopyExpiry: '复制有效期', aRevealCopyCvv: '复制 CVV',
    rvlTitle: '显示卡号 · {card}',
    rvlTip: 'PCI 敏感数据：仅用于客服核对。需输入本人 2FA 动态码并填写查看原因，每次查看都会写入操作日志；明文 30 秒后自动隐藏，关闭抽屉立即清除。',
    rvlTotp: '2FA 动态码', rvlTotpPh: '6 位数字', rvlReason: '查看原因', rvlReasonPh: '如：用户来电核对卡号（必填，≤200 字）',
    rvlPan: '完整卡号', rvlExpiry: '有效期', rvlCvv: 'CVV', rvlAutoHide: '自动隐藏', rvlAutoHideV: '{n} 秒后自动重新掩码',
    rvlErrTotp: '请输入 6 位动态码', rvlErrReason: '请填写查看原因（不超过 200 字）', rvlErrState: '当前卡状态不可查看卡号',
  },
  en: {
    tabCards: ['All', 'Active', 'Frozen', 'Pending', 'Recharging', 'Pre-close', 'Closed', 'Failed'],
    closeCardText:
      'The card will be frozen and its spent amount snapshotted before deletion. Afterwards, max(0, upstream limit − final spent) minus the close fee is refunded to the wallet; any held amount is retained for manual handling. Irreversible.',
    toastRecharge: 'Limit increase submitted',
    toastWithdraw: 'Card transfer-out submitted',
    toastCloseCard: 'Close submitted; refund on completion',
    toastMock: 'Mock transaction sent; card.transaction.update emitted',
    cardMockTitle: 'Mock transaction · {card}', cardMockTip: 'Test environments only: sends a simulated transaction to the upstream sandbox and triggers the webhook. Default Authorize → Settle charges the product transaction fee and sends the fee notification.', cardMockMerchant: 'Merchant name (optional)', cardMockTransition: 'After authorization', cardMockTr_Settle: 'Settle (recommended, charges fee)', cardMockTr_none: 'Authorize only', cardMockTr_Auth_Delete: 'Reverse authorization', cardMockTr_Refund: 'Refund', cardMockTr_Dispute: 'Dispute', cardMockMerchantTooLong: 'Merchant name: at most 255 characters',
    aMockTransition: 'Mock transition', mockTrTitle: 'Mock transition · {tx}', mockTrTip: 'Test environments only: moves an existing upstream transaction to a new status and triggers the webhook. Local status follows the callback — refresh shortly. Leave the amount empty to use the original amount.', mockTrStatus: 'Target status', mockTrAmount: 'Amount (optional, USD)', mockTrTo_Auth_Delete: 'Reverse authorization', mockTrTo_Settle: 'Settle', mockTrTo_Refund: 'Refund', mockTrTo_Dispute: 'Dispute', toastMockTr: 'Mock transition submitted; waiting for the upstream callback',
    upLoading: 'Fetching upstream data…', upNoResponse: 'Upstream not responding', aUpRetry: 'Retry',
    // 以下本计划定稿（06 只给 zh 或未给 en）
    aRecharge: 'Increase limit',
    aWithdraw: 'Transfer out',
    cardTopupTitle: 'Increase limit · {card}',
    cardWithdrawTitle: 'Transfer out · {card}',
    cardOpTip: "Same path as the user's self-service (operator=admin); a background job executes it — see card operations and the timeline for the result",
    stInflight: 'In progress', // 06 C-05
    stillRunning: 'Still processing — refresh later',
    upReadErr: 'Upstream unreadable',
    spentDirty: 'Transactions stored; spent amount pending sync',
    spentUnverified: 'Provider spending snapshot pending; ≥ is known spending and ≤ is the upper bound on available funds',
    aReconcile: 'Reconcile', // 06 C-05
    toastReconcile: 'Reconciliation triggered', // 06 Toast 映射
    crossBorder: 'Cross-border', // 06 C-06
    stTxUnknown: 'Unknown', // 06 C-06
    actOpen: 'Open card',
    actRecharge: 'Limit increase',
    actWithdraw: 'Transfer out',
    actClose: 'Close card',
    actFreeze: 'Freeze',
    actUnfreeze: 'Unfreeze',
    actHold: 'Hold',
    actRelease: 'Release',
    actReclaim: 'Late-claim reclaim',
    caSubmitted: 'Submitted',
    caAccepted: 'Processing upstream',
    caSuccess: 'Success',
    caFailed: 'Failed',
    cardHoldTitle: 'Hold limit · {card}',
    cardReleaseTitle: 'Release hold · {card}',
    holdReviewTip: 'Amount exceeds {threshold}; another admin must review after submission',
    toastHold: 'Hold submitted',
    toastRelease: 'Release submitted',
    crdPendingReview: 'pending review',
    tabCardActions: ['All', 'Pending review', 'Reconciling', 'Failed'],
    toastApprove: 'Approved',
    toastReject: 'Rejected',
    stepAwaitReview: 'Awaiting review',
    stepBudgetTopup: 'Budget top-up',
    stepCreateCard: 'Create card',
    stepFetchDetail: 'Fetch card details',
    stepLimitSync: 'Spent re-check',
    stepLimitUpdate: 'Update limit',
    stepStatusUpdate: 'Update status',
    stepSnapshot: 'Spent snapshot',
    stepDeleteCard: 'Delete card',
    stepFinalize: 'Finalize',
    stepBudgetWithdraw: 'Budget withdrawal',
    stepDone: 'Done',
    reconOutcomeClaimed: 'Claimed',
    reconOutcomeRequeued: 'Not applied upstream; requeued',
    reconOutcomeRoundCounted: 'No match this round',
    reconOutcomeAmbiguous: 'Multiple candidates; bind manually',
    reconOutcomeFailed: 'Marked failed (card opening / limit increase)',
    reconOutcomeAwaitManual: 'Escalated to manual resolution',
    reconOutcomeQueryFailed: 'Upstream query failed (round not counted)',
    reconOutcomeNotUnknown: 'No longer awaiting reconciliation',
    reconOutcomeResumeRejected: 'Could not advance (still reconciling)',
    reconOutcomeBudgetClaimed: 'Pending budget top-up claimed',
    reconOutcomeBudgetPending: 'Pending budget top-up not yet claimed',
    crdOutcomeSuccess: 'Applied upstream',
    crdOutcomeFailed: 'Not applied upstream',
    crdSsPending: 'Pending',
    crdSsSent: 'Sent',
    crdSsAccepted: 'Accepted upstream',
    crdSsUnknown: 'Unconfirmed',
    crdSsWaiting: 'Waiting',
    cTotalLimit: 'Total limit',
    cAvailable: 'Spent / available',
    cHeld: 'Held',
    cExpiry: 'Expiry',
    cBillingAddr: 'Billing address',
    crdBizNo: 'Order no.',
    crdAction: 'Action',
    crdCard: 'Card',
    crdStep: 'Step',
    crdOperator: 'Initiator',
    crdReasonErr: 'Reason / error',
    crdError: 'Error',
    crdNote: 'Note',
    crdCaps: 'Capabilities',
    crdFees: 'Fees',
    crdFinal: 'Closing snapshot',
    crdReviewer: 'Reviewer',
    crdResolver: 'Resolver',
    crdCreatedAt: 'Created',
    crdFinalizedAt: 'Finalized',
    crdTotal: 'Total',
    crdFee: 'Fee',
    limitLocal: 'Customer limit',
    limitUpstream: 'Upstream limit',
    crdErrAmount: 'Enter an amount above 0 with at most 2 decimals',
    errReleaseOverHeld: 'Release cannot exceed the held amount',
    errUpstreamCardId: 'Upstream card ID is required for a successful card creation',
    errResolveNotApplied: 'The order changed; resolution was not applied. Refresh and retry',
    pendingUnknownTip: 'This card has an action awaiting reconciliation',
    aOpenCard: 'Open card',
    aHold: 'Hold',
    aRelease: 'Release',
    holdTip: 'Current total {total} / held {held} / upstream limit {upstream} / spent {spent}.',
    caApproveTitle: 'Approve this order',
    caApproveText: 'The order continues once approved. This cannot be undone.',
    limitTotal: 'Total',
    limitSpent: 'Spent',
    limitAvailable: 'Available',
    cSpent: 'Spent',
    upLimit: 'Upstream limit',
    crdUpRejected: 'rejected upstream',
    crdUpUnavailable: 'unavailable',
    crdFeeOpen: 'Open fee',
    crdFeeClose: 'Close fee',
    crdFeeTx: 'Transaction fee',
    crdFeeCross: 'Cross-border fee',
    crdFeeDeclined: 'Decline fee',
    crdFeeDispute: 'Dispute fee',
    crdBudgetSub: 'Budget #{id}',
    crdFeeLedger: 'Ledger {biz_no} · charged {charged}',
    crdOpUser: 'User',
    crdOpAdmin: 'Admin',
    crdOpSystem: 'System',
    crdYes: 'Yes',
    crdNo: 'No',
    aRevealCard: 'Show card number', aRevealHide: 'Hide card number', aRevealCopyPan: 'Copy card number', aRevealCopyExpiry: 'Copy expiry', aRevealCopyCvv: 'Copy CVV',
    rvlTitle: 'Show card number · {card}',
    rvlTip: 'PCI-sensitive data for support verification only. Enter your own 2FA code and a reason; every view is written to the operation log. Details re-mask after 30 seconds and are cleared as soon as the drawer closes.',
    rvlTotp: '2FA code', rvlTotpPh: '6 digits', rvlReason: 'Reason', rvlReasonPh: 'e.g. caller verifying the card (required, ≤200 chars)',
    rvlPan: 'Card number', rvlExpiry: 'Expiry', rvlCvv: 'CVV', rvlAutoHide: 'Auto-hide', rvlAutoHideV: 'Re-masks in {n} seconds',
    rvlErrTotp: 'Enter the 6-digit code', rvlErrReason: 'Enter a reason (200 characters max)', rvlErrState: 'Card number is not viewable in the current card status',
  },
};

// 覆盖原型字典键（06 [改写 key] / Toast 映射 [改写] / 附录 A-13）
export const REWRITES_CARDS: readonly string[] = ['tabCards', 'closeCardText', 'toastRecharge', 'toastWithdraw', 'toastCloseCard', 'toastMock', 'aRecharge', 'aWithdraw'];
